import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { setUserState } from '../../store/user'
import withNavigate from './withNavigate'
import constants from '../../utils/constants';
import API from '../../utils/API'

/**
 * Component that prevents access to the route under it unless the user is authenticated.
 * If the user has been assigned a role then the user is allowed in.
 */
function PrivateRoute(props) {
  const [hasAuthenticatedFinished, setHasAuthenticatedFinished] = useState(false); //Flag to check if authenticate API is complete
  // const [hasActivated, setHasActivated] = useState(false);
  const [needsChangePassword, setNeedsChangePassword] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const { user } = props;

  useEffect(() => {
    if (user.id) {
      setHasAuthenticatedFinished(true)
    } else {
      API.authenticate()
        .then((userRes) => {
          let user = userRes.data.user;
          if (userRes.data.user) {
            props.dispatch(setUserState(userRes.data.user))
          } else {
            console.log('Invalid credentials')
          }
          API.getGlobalPolicies()
          .then((policyRes)=>{
            const firstLoginSetting = policyRes.data.find(setting => setting.global_policy_id === constants.globalPolicies.firstLogin);
            if(firstLoginSetting) {
              if(userRes.data.user.status === 0) {
                setNeedsChangePassword(true);
              }
            }
          })
          setHasAuthenticatedFinished(true)
          setAuthenticated(true);
        })
        .catch((err) => {
          console.log(err);
          setHasAuthenticatedFinished(true)
          setAuthenticated(false);
        })
    }
  }, [props, user.id]);
  if (hasAuthenticatedFinished) {
    if(authenticated) {
      if(needsChangePassword) {
        return <Navigate to="/change-password" />
      }
      else {
        return props.children
      }
    }
    return <Navigate to="/login"/>
  }
  return null //Authenticated not done

}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(withNavigate(PrivateRoute))